import { FunctionComponent, useEffect, useState } from "react"
import { DateTime, Duration } from 'luxon'
import React from "react"
/**
 * We are using Luxon for dealing with dates and times.
 * It works as a wrapper for Intl internationalization library
 * For more information https://moment.github.io/luxon/index.html#/
 * For set of Presets eg. DATE_SHORT etc see https://moment.github.io/luxon/index.html#/formatting?id=presets
 * or https://moment.github.io/luxon/api-docs/index.html
 */

interface ICountdownTimer {
	isTimedOut: Function
	format: string
	time?: {
		year?: number
		month?: number
		days?: number
		hours?: number
		minutes?: number
		seconds?: number
		expiryDate?: Date
	}
}

/**
 * Countdown timer
 * @param isTimedOut true when reaches zero
 * @param format format of counter value ex. ("dd 'days' mm:ss 'minutes'"")
 * @param time (Default value 10 minutes)
 * @param time.days
 * @param time.hours
 * @param time.minutes
 * @param time.seconds
 * @param time.expiryDate will ignore all other time properties if provided
 * @returns Countdown element
 */
export const CountdownTimer: FunctionComponent<ICountdownTimer> = ({
	isTimedOut,
	format,
	time = { minutes: 10 },
}) => {
	let duration: Duration

	if (time.expiryDate) {
		const dur = new Date(time.expiryDate).getTime() - new Date().getTime()
		duration = Duration.fromMillis(dur)
	} else {
		duration = Duration.fromObject(time)
	}

	const [difference, setDifference] = useState(
		DateTime.now().plus(duration).diff(DateTime.now())
	)

	const timeIsUp = difference.get('seconds') < -duration.as('seconds')

	useEffect(() => {
		let id = setInterval(
			() => setDifference((state: { minus: (arg0: { second: number }) => any }) => state.minus({ second: 1 })),
			1000
		)
		return () => clearInterval(id)
	}, [])

	useEffect(() => {
		if (timeIsUp) isTimedOut(true)
	})

	return <>{difference.toFormat(format)}</>
}